import React from 'react';
import * as RadixToggle from '@radix-ui/react-toggle';
import classNames from 'classnames';

import styles from './Toggle.module.scss';

export interface IToggleProps extends Omit<RadixToggle.ToggleProps, 'prefix'> {
    size?: 'small' | 'medium' | 'large';
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
}

export const Toggle = ({ size = 'large', prefix, suffix, children, ...props }: IToggleProps) => {
    return (
        <RadixToggle.Root
            {...props}
            className={classNames(styles.toggle, styles[`size-${size}`], {
                [styles.withPrefix]: !!prefix,
                [styles.withSuffix]: !!suffix,
            })}
        >
            {prefix}
            {children}
            {suffix}
        </RadixToggle.Root>
    );
};
